import {
  AiFillLinkedin,
  AiOutlineArrowRight,
  AiOutlineCheckCircle,
  AiOutlineHeart,
} from "solid-icons/ai";
import { useI18n } from "@/api/i18n";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface JobOfferSuccessLayoutProps {
  onGoToATS: () => void;
  onMakeDonation: () => void;
  onShareLinkedIn: () => void;
}

export const JobOfferSuccessLayout = (props: JobOfferSuccessLayoutProps) => {
  const { t } = useI18n();

  return (
    <div class="min-h-screen flex items-center justify-center bg-gray-50">
      <div class="max-w-4xl w-full mx-auto px-4">
        <div class="text-center mb-8">
          {/* Success Icon */}
          <div class="flex justify-center mb-6">
            <div class="w-20 h-20 rounded-full border-4 border-primary flex items-center justify-center bg-white">
              <AiOutlineCheckCircle size={40} class="text-primary" />
            </div>
          </div>

          {/* Title */}
          <h1 class="text-3xl font-display font-bold mb-4">
            {t("jobOffers.create.success.title")}
          </h1>

          {/* Subtitle */}
          <p class="text-lg text-gray-600 max-w-2xl mx-auto">
            {t("jobOffers.create.success.subtitle")}
          </p>
        </div>

        {/* Action Cards */}
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          {/* Share on LinkedIn Card */}
          <Card class="border-2 border-gray-200 hover:border-gray-300 transition-colors shadow-none">
            <CardContent class="p-6">
              <div class="flex flex-col h-full">
                <div class="flex items-start gap-4 mb-4">
                  {/* Icon */}
                  <div class="w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center shrink-0">
                    <AiFillLinkedin size={24} class="text-blue-600" />
                  </div>

                  {/* Content */}
                  <div class="flex-1">
                    <h3 class="text-lg font-display font-semibold text-black mb-2">
                      {t("jobOffers.create.success.shareLinkedIn.title")}
                    </h3>
                    <p class="text-sm text-gray-600 leading-relaxed">
                      {t("jobOffers.create.success.shareLinkedIn.description")}
                    </p>
                  </div>
                </div>

                {/* Button aligned to bottom */}
                <div class="mt-auto">
                  <Button
                    onClick={props.onShareLinkedIn}
                    class="w-full bg-[#0A66C2] hover:bg-[#004182] text-white"
                    aria-label={t(
                      "jobOffers.create.success.shareLinkedIn.title",
                    )}
                  >
                    {t("jobOffers.create.success.shareLinkedIn.button")}
                    <AiFillLinkedin size={16} class="ml-2" />
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Support Platform Card */}
          <Card class="border-2 border-gray-200 hover:border-gray-300 transition-colors shadow-none">
            <CardContent class="p-6">
              <div class="flex flex-col h-full">
                <div class="flex items-start gap-4 mb-4">
                  {/* Icon */}
                  <div class="w-12 h-12 rounded-lg bg-matisse-50 flex items-center justify-center shrink-0">
                    <AiOutlineHeart size={24} class="text-matisse-600" />
                  </div>

                  {/* Content */}
                  <div class="flex-1">
                    <h3 class="text-lg font-display font-semibold text-black mb-2">
                      {t("jobOffers.create.success.donate.title")}
                    </h3>
                    <p class="text-sm text-gray-600 leading-relaxed">
                      {t("jobOffers.create.success.donate.description")}
                    </p>
                  </div>
                </div>

                {/* Button aligned to bottom */}
                <div class="mt-auto">
                  <Button
                    variant="outline"
                    onClick={props.onMakeDonation}
                    class="w-full"
                  >
                    {t("jobOffers.create.success.donate.button")}
                    <AiOutlineHeart size={16} class="ml-2" />
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
        <div class="mt-auto text-center">
          <Button onClick={props.onGoToATS} variant="outline" class="min-w-1/2">
            {t("jobOffers.create.success.manageAts.button")}
            <AiOutlineArrowRight size={16} class="ml-2" />
          </Button>
        </div>
      </div>
    </div>
  );
};
